module.exports = __webpack_public_path__ + "static/media/footeBackground.29f8f294.svg";